import { render, staticRenderFns } from "./PlatonFormAdminModalActions.vue?vue&type=template&id=1df42107&"
import script from "./PlatonFormAdminModalActions.vue?vue&type=script&lang=js&"
export * from "./PlatonFormAdminModalActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports